import { render, staticRenderFns } from "./OrderProductionBatchDetail.vue?vue&type=template&id=6fee6214&scoped=true&"
import script from "./OrderProductionBatchDetail.vue?vue&type=script&lang=js&"
export * from "./OrderProductionBatchDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrderProductionBatchDetail.vue?vue&type=style&index=0&id=6fee6214&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fee6214",
  null
  
)

export default component.exports